module.exports = __webpack_public_path__ + "static/TradeGothicLTStd-BdCn20-09bad90f91f6a92b24e1dfe51e4e43bd.woff2";